import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useTranslation from "@babackapp/translations/use-translation";
import useQuickStats from "../lib/use-quick-stat";
import { exchangeColor } from "./colors";
import { QuickStatCard } from "./quick-stat-card";

export default function QuickStatExchangeCard() {
  const stats = useQuickStats("exchange");
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();

  return (
    <QuickStatCard
      count={stats.count}
      value={stats.value}
      currency={shop.preferences.currency}
      evolution={5}
      title={t("analyticsDashboard.resolutionTypes.exchange")}
      subtitle={t("analyticsDashboard.quickStats.exchange")}
      percentage={stats.percentage}
      color={exchangeColor}
    />
  );
}
